/**
 * Sticky finish bar — the completion moment (§1.6, WR-4/WR-15). Enabled once
 * every suggestion card and untouched-objective question has been answered;
 * a quiet disabled state plus a pending count otherwise (never red/blocked).
 * After completion the bar becomes a quiet closing line, no longer a button.
 */
export function FinishBar({
  completed,
  pendingCount,
  reviewCompletedXp,
  onFinish,
}: {
  readonly completed: boolean;
  readonly pendingCount: number;
  readonly reviewCompletedXp: number;
  readonly onFinish: () => Promise<void>;
}) {
  return (
    <div
      style={{
        position: 'sticky',
        bottom: 'var(--space-5)',
        background: 'var(--surface-overlay)',
        border: '1px solid var(--border-subtle)',
        borderRadius: 'var(--radius-lg)',
        boxShadow: 'var(--shadow-2)',
        padding: 'var(--space-4)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {completed ? (
        <p style={{ margin: 0, fontSize: 'var(--type-body-size)', color: 'var(--text-secondary)', textAlign: 'center' }}>
          Done. See you next Sunday.
        </p>
      ) : pendingCount > 0 ? (
        <p style={{ margin: 0, fontSize: 'var(--type-body-size)', color: 'var(--text-secondary)' }}>
          {pendingCount} question{pendingCount === 1 ? '' : 's'} left
        </p>
      ) : (
        <button
          type="button"
          onClick={() => void onFinish()}
          style={{
            minHeight: '52px',
            padding: '0 var(--space-6)',
            borderRadius: 'var(--radius-md)',
            background: 'var(--hue-primary-vivid)',
            color: 'var(--text-on-accent)',
            fontWeight: 600,
            fontSize: 'var(--type-body-size)',
            border: '1px solid var(--hue-primary-strong)',
          }}
        >
          Finish review — +{reviewCompletedXp} XP
        </button>
      )}
    </div>
  );
}
